"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _coreLink = _interopRequireDefault(require("@legacy-vfuk/core-link"));

var _coreDivider = _interopRequireDefault(require("@legacy-vfuk/core-divider"));

var _coreMatchMedia = require("@legacy-vfuk/core-match-media");

var Styled = _interopRequireWildcard(require("./styles/LegalLinks.style"));

var _hooks = require("../../hooks");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var LegalLinks = function LegalLinks(_ref) {
  var legalLinks = _ref.legalLinks,
      onInteractionClick = _ref.onInteractionClick;

  var _useBreakpoints = (0, _coreMatchMedia.useBreakpoints)(),
      sm = _useBreakpoints.sm,
      md = _useBreakpoints.md;

  var getLinksRowLength = function getLinksRowLength() {
    if (sm) return 2;
    if (md) return 3;
    return 6;
  };

  var linksList = (0, _hooks.useLinksList)(legalLinks, getLinksRowLength());
  return /*#__PURE__*/_react["default"].createElement(Styled.LinksWrapper, null, linksList.map(function (row, rowIndex) {
    return /*#__PURE__*/_react["default"].createElement(Styled.LinksRow, {
      key: rowIndex
    }, /*#__PURE__*/_react["default"].createElement(Styled.RowListGroup, null, row.map(function (link, linkIndex) {
      return /*#__PURE__*/_react["default"].createElement(Styled.ListItemWrapper, {
        key: link.id
      }, /*#__PURE__*/_react["default"].createElement(_coreLink["default"], {
        href: link.url,
        to: link.to,
        onClick: onInteractionClick,
        inverse: true
      }, link.text), linkIndex !== row.length - 1 ? /*#__PURE__*/_react["default"].createElement(_coreDivider["default"], {
        orientation: "vertical",
        appearance: "secondary",
        inverse: true
      }) : null);
    })));
  }));
};

LegalLinks.displayName = "LegalLinks";
var _default = LegalLinks;
exports["default"] = _default;
//# sourceMappingURL=LegalLinks.js.map